// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"vh","categoryName":"wh","categoryImage":"xh","categoryContent":"yh","bottomAligned":"zh"};